import { render, staticRenderFns } from "./heroNews.vue?vue&type=template&id=3fc7818c&scoped=true&"
import script from "./heroNews.vue?vue&type=script&lang=js&"
export * from "./heroNews.vue?vue&type=script&lang=js&"
import style0 from "./heroNews.vue?vue&type=style&index=0&id=3fc7818c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7818c",
  null
  
)

export default component.exports